// Atomique × Horizon — scroll reveal + header scroll state
(function () {
  'use strict';

  // Scroll reveal (IntersectionObserver)
  const revealEls = document.querySelectorAll('.atm-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('atm-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('atm-in-view'));
  }

  // Add 'scrolled' class to header for frosted-glass effect
  const headerComponent = document.querySelector('header-component');
  if (headerComponent) {
    const onScroll = () =>
      headerComponent.classList.toggle('scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
